import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/modules/shared/services/http/http.service';
import { HttpClient } from '@angular/common/http';
import { travelCashUrl, travelCashApproverUrl } from 'src/app/modules/shared/common/api';

@Injectable()
export class TravelCashService extends HttpService{

  constructor(http: HttpClient) { 
   super('',http);
 }

 getFilter() {
   return this.get().map(res => {
     return res['data'];
   }); 
 }

 storeCash(data){
  return this.http.post(travelCashUrl, data).map((dataResponse) => {
    return dataResponse;
  });
 }

 updateCash(id,data) {
  return this.http.put(travelCashUrl + '/' + id , data).map((dataResponse) => {
    return dataResponse;
  });
 }

 updateStatus(id,data) {
  return this.http.put(travelCashUrl + '/status/' + id , data).map((dataResponse) => {
    return dataResponse;
  });
 }

 
 approverUpdateStatus(id,data) {
    return this.http.put(travelCashApproverUrl + '/status/' + id , data).map((dataResponse) => {
      return dataResponse;
    });
  }

}
